import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { getCategoryTree } from '../../../app/api';
import { flattenCategoryTree, normalizeCategoryTreeNode } from '../public/categoryUtils';
import { useTranslation } from '../../../app/LanguageContext';

export default function CategoryParentSelect({ value, onChange, excludeId = '', disabled = false }) {
  const { translate } = useTranslation();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await getCategoryTree();
        const tree = (res.data?.tree ?? res.data?.Tree ?? []).map(normalizeCategoryTreeNode).filter(Boolean);
        const flat = flattenCategoryTree(tree).filter((c) => c.id !== excludeId);
        setOptions(flat);
      } catch {
        setOptions([]);
      }
    })();
  }, [excludeId]);

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel>{translate('categories.parent')}</InputLabel>
      <Select
        label={translate('categories.parent')}
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value || '')}
      >
        <MenuItem value="">{translate('categories.no_parent')}</MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id} sx={{ pl: 2 + opt.depth * 2 }}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
